import api from "./index";

export default {
  async create(data) {
    const response = await api.post("/business_enquiries", data);
    return response;
  }
};
